import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

// const root = ReactDOM.createRoot(document.getElementById('root'));
ReactDOM.render(<App />, document.getElementById("root"));
